import CityPageTemplate from "@/pages/city-template/CityPageTemplate";
import { carbondaleConfig } from "./data";

export default function CarbondalePage() {
  return <CityPageTemplate config={carbondaleConfig} />;
}